import { OTPEnterVerificationTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const OTPEnterVerificationTrackingSchema: Record<
  OTPEnterVerificationTrackingPoint,
  string
> = {
  [OTPEnterVerificationTrackingPoint.PageView]:
    '002d298b-b804-4851-a94e-6d5b8328769e',
  // Note: the button's text is "OK" but it is the same "Next" button
  [OTPEnterVerificationTrackingPoint.NextButtonClick]:
    '14f130bf-d2ba-4066-93d0-6240d7948fec',
  [OTPEnterVerificationTrackingPoint.BackButtonClick]:
    '1d1c5a24-8251-4c61-82d5-a71224a46b60',
  [OTPEnterVerificationTrackingPoint.HelpButtonClick]:
    'c07562ca-5ce6-49be-89bd-f882274a6176',
  [OTPEnterVerificationTrackingPoint.ResendButtonClick]:
    '4c626074-5d4d-4771-a39e-d05a7dcf2bc9',
  [OTPEnterVerificationTrackingPoint.DifferentMethodButtonClick]:
    '66ee3237-5a4a-490a-a214-889a542d45e6',
  [OTPEnterVerificationTrackingPoint.VerificationResult]:
    '8db12fa7-1754-469e-83a6-491f9aeb7861',
  [OTPEnterVerificationTrackingPoint.PhoneAlreadyUsedView]: '',
  [OTPEnterVerificationTrackingPoint.PhoneAlreadyUsedOkButtonClick]: '',
  [OTPEnterVerificationTrackingPoint.PhoneAlreadyUsedContactUsButtonClick]: '',
  [OTPEnterVerificationTrackingPoint.EmailAlreadyUsedView]: '',
  [OTPEnterVerificationTrackingPoint.EmailAlreadyUsedOkButtonClick]: '',
  [OTPEnterVerificationTrackingPoint.EmailAlreadyUsedContactUsButtonClick]: '',
  [OTPEnterVerificationTrackingPoint.AccountBannedPopupView]: '',
  [OTPEnterVerificationTrackingPoint.AccountBannedPopupOkButtonClick]: '',
  [OTPEnterVerificationTrackingPoint.AccountBannedPopupContactUsButtonClick]:
    '',
};

export const getOTPEnterVerificationPageTypeAndSchema = (
  trackingPoint: OTPEnterVerificationTrackingPoint
) => {
  return {
    page_type: PageType.OTPEnterVerificationPage,
    schema: OTPEnterVerificationTrackingSchema[trackingPoint],
  };
};
